import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-137cf7a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { id: "summary-page-title" }, "Summary", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "summary-page-block" }
const _hoisted_4 = { class: "summary-box" }
const _hoisted_5 = { class: "summary-box-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Property Address", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "summary-information" }
const _hoisted_10 = { class: "summary-box" }
const _hoisted_11 = { class: "summary-box-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Purchaser Details", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "summary-information" }
const _hoisted_16 = { class: "summary-page-block" }
const _hoisted_17 = { class: "summary-box" }
const _hoisted_18 = { class: "summary-box-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Energy Details", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "summary-information" }

import { PropType, computed, ref } from "vue";
import { Address } from "@/types/generic/Address";
import scrollView from "@/components/ui/scroll-view.vue";
import { GenericPersonalDetails } from "@/types/switches/GenericPersonalDetails";


export default /*#__PURE__*/_defineComponent({
  __name: 'purchaser-summary',
  props: {
  /**
   * The selected energy address for the component.
   * @type {Address}
   * @required
   */
  energySelectedAddress: {
    type: Object as PropType<Address>,
    required: true,
  },

  /**
   * The personal information of the purchaser.
   * @type {GenericPersonalDetails}
   * @required
   */
  purchaserPersonalInfo: {
    type: Object as PropType<GenericPersonalDetails>,
    required: true,
  },

  /**
   * The type of energy being used or referenced in the component.
   * @type {string}
   * @required
   */
  energyType: {
    type: String,
    required: true,
  },

  /**
   * The model value representing the current state or selection, typically a number.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },

  /**
   * Indicates whether the edit buttons should be disabled.
   * @type {boolean}
   * @default false
   */
  disableEditButtons: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const pageId = computed({
  get: () => props.modelValue,
  set: (value: number) => emit("update:modelValue", value),
});

const editDetails = (pageNumber: number) => {
  if (props.disableEditButtons) {
    return;
  }
  pageId.value = pageNumber;
};

const screeWidth = ref(screen.width);

const smallScreen = computed(() => screeWidth.value < 875);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(scrollView, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("section", {
        class: _normalizeClass(["summary-page", { smallScreen: smallScreen.value }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (editDetails(0))),
                class: "icon"
              }, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.propertyName), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.street), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.locality), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.town), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.locality), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.region), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.postCode), 1)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editDetails(2))),
                class: "icon"
              }, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(props.purchaserPersonalInfo.firstName) + " " + _toDisplayString(props.purchaserPersonalInfo.lastName), 1),
                _createElementVNode("li", null, _toDisplayString(props.purchaserPersonalInfo.number), 1),
                _createElementVNode("li", null, _toDisplayString(props.purchaserPersonalInfo.email), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("section", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (editDetails(1))),
                class: "icon"
              }, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(props.energyType), 1)
              ])
            ])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})